import React from 'react'
import { Link } from 'react-router-dom'
import TimeAgo from 'react-timeago'



class Update1 extends React.Component{



render() {

  return(
  <div>
    <h1 className="introduction-header" >Hybrid Update 1.0</h1>
    <p className="introduction-p-italic">
    By Nathan Sellers <TimeAgo date="Aug 31, 2018" />
    </p>
      <p className="introduction-p"> Calling all <span className="orange">Newforma Developers</span>!</p>
      <p className="introduction-p"> We are happy to announce the release of our new RESTful APIs. In this first release we have exposed
        many key resources. You can now manage via APIs <span className="blue">Action Items</span>, <span className="blue">Files</span>, <span className="blue">Projects</span>,
        <span className="blue">Shared Items</span> and make use of Newforma's powerful <span className="blue">Project Search</span> capability. We have also made available
        many resources that will help build your integrations, for more information please see our <Link to="nlreference">API Reference</Link> inside the
        <Link to="/documentation"> Documentation</Link> page.

      </p>


      <p className="introduction-p"> We of course will not be stopping here, everyday our Developers are working hard to create more powerful API resources to give
        you access to the information you need. Please visit the Updates page frequently to keep up with the most recent releases.

      </p>

    </div> )
}
}
export default Update1;



/** WEBPACK FOOTER **
 ** ./src/pages/Updates/update1.js
 **/